import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="banner-form"
export default class extends Controller {
  static targets = [
    "type",
    "enabled",
    "message",
    "background",
    "occurrence",
    "dismissible",
  ]

  connect() {
    const dataElement = document.getElementById("banner-settings-data")
    this.settings = JSON.parse(dataElement.textContent)
    this.updateFormFields(this.typeTarget.value)
  }

  changeType(event) {
    const type = event.target.value
    this.updateFormFields(type)
  }

  updateFormFields(type) {
    const config = this.settings[type] || {}

    // populate form
    this.enabledTarget.checked = !!config.enabled
    this.messageTarget.value = config.message || ""
    this.backgroundTarget.value = config.background || ""
    this.occurrenceTarget.value = config.occurrence || ""
    this.dismissibleTarget.checked = !!config.dismissible
  }
}
